import { useReducer } from "react";
import { AdvancedSelectionState, isAdvancedSelectionEmpty } from "../Tags/reducers/advancedSelectionReducers";
import { TeamPreviewFragment } from "apps/web/src/types";

interface ShareByTeamsState {
    __typename: "Teams";
    teams: readonly TeamPreviewFragment[];
    advancedSelectionState: null;
}

interface ShareByAdvanceSelectionState {
    __typename: "Tags";
    teams: null;
    advancedSelectionState: AdvancedSelectionState;
}

interface ChangeTeamsAction {
    type: "ChangeTeamsAction";
    payload: { teams: readonly TeamPreviewFragment[] };
}

interface ChangeAdvancedSelectionAction {
    type: "ChangeAdvancedSelectionAction";
    payload: { advancedSelectionState: AdvancedSelectionState };
}

interface ClearAdvancedSelectionAction {
    type: "ClearAdvancedSelectionAction";
}

export type AssignGoalAdvancedSelectionAction = ChangeTeamsAction | ChangeAdvancedSelectionAction | ClearAdvancedSelectionAction;
export type AssignGoalAdvancedSelectionState = ShareByAdvanceSelectionState | ShareByTeamsState;

const getEmptyShareState = (): AssignGoalAdvancedSelectionState => ({
    __typename: "Teams",
    teams: [],
    advancedSelectionState: null,
});

const assignGoalAdvancedSelectionReducer = (
    state: AssignGoalAdvancedSelectionState,
    action: AssignGoalAdvancedSelectionAction
): AssignGoalAdvancedSelectionState => {
    switch (action.type) {
        case "ChangeTeamsAction":
            if (state.__typename === "Tags") {
                console.error("Cannot assign teams when advancedSelectionState has value");
                return state;
            }
            return { ...state, teams: action.payload.teams };

        case "ClearAdvancedSelectionAction":
            return getEmptyShareState();

        case "ChangeAdvancedSelectionAction":
            return isAdvancedSelectionEmpty(action.payload.advancedSelectionState)
                ? getEmptyShareState()
                : { __typename: "Tags", teams: null, advancedSelectionState: action.payload.advancedSelectionState };
    }
};

export const useAdvancedSelection = () => {
    return useReducer(assignGoalAdvancedSelectionReducer, getEmptyShareState());
};
